import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2 } from 'lucide-react';
import { Badge } from './ui/badge';
import { Button } from './ui/button';

const PHOTO = 'https://customer-assets-jai6qajn.emergentagent.net/job_2b41e164-3d6f-488e-a974-c4593600dbb3/artifacts/syif6cvb_YOG07455-removebg-preview.png';
const CARD_BG = '#26262b';

const WelcomeSection = () => {
  const navigate = useNavigate();
  return (
    <section className="py-8 md:py-10 bg-black" data-testid="welcome-section">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-10">
          <Badge className="bg-red-600/20 text-red-400 border-red-500/30 mb-4">Boas-vindas</Badge>
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            Seja bem-vindo(a) à <span className="text-red-500">AJ Consultoria e Gestão em BIM</span>
          </h2>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <div
            className="relative rounded-2xl border border-zinc-800 overflow-hidden shadow-xl"
            style={{ backgroundColor: CARD_BG }}
          >
            {/* Foto */}
            <div className="absolute right-0 bottom-0 top-0 w-[42%] md:w-[34%] hidden sm:flex items-end justify-center">
              <img
                src={PHOTO}
                alt="Alexander Justi"
                className="h-[92%] w-auto object-contain object-bottom drop-shadow-2xl"
              />
              <div
                className="absolute inset-0 pointer-events-none"
                style={{ background: `linear-gradient(to right, ${CARD_BG} 0%, ${CARD_BG}99 18%, transparent 55%)` }}
              />
            </div>

            {/* Conteúdo */}
            <div className="relative p-7 md:p-12 sm:pr-[40%] md:pr-[34%] min-h-[340px] flex flex-col justify-center">
              <div className="sm:hidden mb-5 flex justify-center">
                <img src={PHOTO} alt="Alexander Justi" className="h-56 w-auto object-contain" />
              </div>

              <span className="inline-block border-2 border-orange-500 text-orange-500 rounded-full px-6 py-2 text-xs font-bold tracking-[0.15em] uppercase mb-5 w-fit">
                Quem Somos
              </span>

              <p className="text-gray-200 text-base md:text-lg leading-relaxed mb-4">
                A <span className="text-white font-semibold">AJ Consultoria e Gestão em BIM</span> é referência em
                educação, consultoria e implantação de BIM no Brasil desde 2005. Reunimos formação, tecnologia,
                serviços e uma comunidade completa em um só lugar — o <span className="text-white font-semibold">BIMPORTAL</span>.
              </p>

              <div className="mb-5">
                <span className="block font-bold text-white text-base md:text-lg">Alexander Justi</span>
                <span className="text-gray-400 text-sm md:text-base">Responsável Técnico pelo Ecossistema do BIMPORTAL</span>
              </div>

              <blockquote className="border-l-4 border-red-500 pl-4 text-gray-100 italic text-sm md:text-base leading-relaxed" data-testid="welcome-quote">
                “Se estava procurando um local onde se <span className="text-red-400 not-italic font-semibold">“respira BIM”</span>, você encontrou.
                Neste portal, poderá aprender, fazer network e localizar profissionais e empresas especializadas,
                contar com a ajuda de uma IA especializada no assunto e muito mais. Com a ajuda da
                <span className="text-white not-italic font-semibold"> AJ | BIM ACADEMY</span> você se tornará um profissional
                requisitado no mercado. Se está procurando um simples curso de Revit, o local não é esse…
                seja bem-vindo(a) ao novo mundo BIM.”
              </blockquote>

              <Button
                onClick={() => navigate('/sobre-empresa')}
                variant="outline"
                size="sm"
                className="mt-6 w-fit border-red-500 text-red-500 hover:bg-red-500/10"
                data-testid="welcome-nossa-historia-btn"
              >
                Nossa História
                <Building2 className="ml-2" size={14} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
